import type {
  CourseEvaluatorReviewDecision,
  CourseEvaluatorReviewSidebarItemMock,
} from "../mockData/courseEvaluatorReview.mockData";

interface ReviewActionPanelProps {
  selectedReviewItem: CourseEvaluatorReviewSidebarItemMock | null;
  decision: CourseEvaluatorReviewDecision;
  onAccept?: () => void;
  onReject?: () => void;
  onUndo?: () => void;
}

function ReviewActionPanel(_props: ReviewActionPanelProps) {
  return null;
}

export default ReviewActionPanel;
